export default __webpack_public_path__ + "static/media/spikes_3.55dfee69.svg";